import ButtonTabs from './ButtonTabs';
import './ButtonTabs.scss';

export default ButtonTabs;